import axios from 'axios';
export const GET_RECIPES = 'GET_RECIPES'
export const FILTER_BY_DIET= 'FILTER_BY_DIET'
export const ORDER_BY_NAME = 'ORDER_BY_NAME'
export const GET_NAME_RECIPES = 'GET_NAME_RECIPES'
export const ORDER_BY_HEALTHSCORE = 'ORDER_BY_HEALTHSCORE'
export const RECIPE_DETAIL = 'RECIPE_DETAIL'
export const POST_RECIPE = 'POST_RECIPE'
export const GET_DIETS = 'GET_DIETS'
export const ORDER_BY_CREATEDORAPI='ORDER_BY_CREATEDORAPI'
export const FILTER_BY_SCORE='FILTER_BY_SCORE'
export const LIMPIAR_FILTRO= 'LIMPIAR_FILTRO'

export function getAllRecipes(){
    return async function (dispatch){
        var resuResetas = await axios.get('https://pi-food-backk.herokuapp.com/recipes');
        console.log('estoy en el getAllRecipes', resuResetas.data)
        return dispatch({
            type: GET_RECIPES,
            payload: resuResetas.data
        })
    }
}
export function getNameRecipes(name){ //name es lo mismo que payload
    return async function(dispatch){
        try {
            var json = await axios(`https://pi-food-backk.herokuapp.com/recipes?name=${name}`)
            return dispatch({
                type: GET_NAME_RECIPES,
                payload: json.data //Este json.data es lo que devuele la ruta una vez que yo le asigne un name
            })
        } catch(error){
            console.log(error)
        }
    }
}
// export function postRecipe(front){
    //     return async function(dispatch){
        //         const response = await axios.post('http://localhost:3001/recipes', front) //Quiero en esta ruta, hacer el post del payload, el payload es lo que me llega por el front
        //         const data = await response.data;
        //         return dispatch({
            //             type: POST_RECIPE,
            //             payload
            //         })
            //     }
            // }
//----------------Crear Recipe----------------------------
export const addRecipe = (body) => {
    return async function (dispatch) {
    console.log('Soy bodyyyyyyyyyy'+ body)
      return axios
        .post('https://pi-food-backk.herokuapp.com/recipes', body)
        .then((res) => dispatch({ type: POST_RECIPE, payload: res.data }));
    };
  };
//   export function getDiet(){
//     return async function(dispatch){
//         const resu =  await axios('/diets')
//         dispatch({
//             type: GET_DIETS,
//             payload: resu.data
//         })
//     }
// }
    export function getDiet(){
        return async function (dispatch) {
            return axios
            .get('https://pi-food-backk.herokuapp.com/diets')
            .then((res) => dispatch({ type: GET_DIETS, payload: res.data }))
            .catch((e) => {
                console.log("error buscando las dietas");
                console.log(e);
            });
        };
    }
//----------------Crear Recipe----------------------------


//la accion es despachar un tipo, la logica la armamos en el reducer
export function filterRecipesByDiet(payload){
    console.log(payload)
    return{
        type: FILTER_BY_DIET,
        payload
    }
} 
export function orderByName(payload){
    return {
        type: ORDER_BY_NAME,
        payload
    }
}

export function orderByHealthScore(payload){
    return{
        type: ORDER_BY_HEALTHSCORE,
        payload
    }
}

export function orderByCreated(payload){
    return{
        type: ORDER_BY_CREATEDORAPI,
        payload
    }
}


export function recipesDetail(id){
    return function(dispatch){
        return axios.get(`https://pi-food-backk.herokuapp.com/recipes/${id}`)
        .then(d => d.data)
        .then(data => dispatch({
            type: RECIPE_DETAIL,
            payload:data
        }))
    }
}
export function Limpiarfiltro(payload){
    return{
        type: LIMPIAR_FILTRO,
        payload: payload
    }
}
